<script>
    import { preventDefault } from 'svelte/legacy';

    import {
        modalState, hideModal
    } from '@app/store/modalStore.svelte.js';
    import {
        eventGroupState, isEventGroupLocked
    } from '@app/store/eventGroupStore.svelte.js';
    import {
     insertHistoryAction
    } from '@app/store/historyStore.svelte.js';
    import {
        projectState
    } from '@app/store/projectStore.svelte.js';
    import { toast } from '@zerodevx/svelte-toast';
    import {
        fade
    } from 'svelte/transition';
    import * as m from '@app/paraglide/messages.js';
    
    let srcGroupId = $state(""), trgGroupId = $state("");

    function copyTimecodesFromGroup(){
        try {
            let srcIndex = eventGroupState.findIndex(eventGroup =>{
            return eventGroup.id === srcGroupId;
            });

            let trgIndex = eventGroupState.findIndex(eventGroup =>{
                return eventGroup.id === trgGroupId;
            });

            if (srcIndex === trgIndex){
                throw new Error(m.source_target_match_error());
            }

            if (isEventGroupLocked(trgIndex)) {
                throw new Error(m.event_group_locked_toast());
            }
            
            eventGroupState[srcIndex].events.forEach((event, index) => {
                if (eventGroupState[trgIndex].events[index]){
                    eventGroupState[trgIndex].events[index].start = event.start;
                    eventGroupState[trgIndex].events[index].end = event.end;
                }
            });

            toast.push(m.timecodes_copied_success(), {
                classes: ["toast-success"]
            });

            insertHistoryAction({
                name: "copy timecode", //action name
                eventGroup: projectState.selected,
                snapshots: [{
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState)
                }]
            });
        } catch(err){
            console.log(err, err.message);

            toast.push(m.timecode_copy_failed(), {
                classes: ["toast-danger"]
            });
        } finally {
            hideModal();
        }
    }
    
    </script>
    
    <div transition:fade={{duration: 100}} class="modal {modalState.selected === 'copyTcFromGroup' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="copyTcModalTitle"
    aria-describedby="copyTcModalDesc"
    tabindex="-1" 
    id="CopyTcModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="copyTcModalTitle">{m.tc_copy()}</h4>
                <button type="button" class="btn-close" id="closeTcCopyBtn" aria-label={m.close_dialog()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="copyTcModalDesc" class="visually-hidden">{m.copy_timecodes_description()}</p>
                <form onsubmit={preventDefault(copyTimecodesFromGroup)}>
                    <div class="mb-3">
                        <label class="form-label" for="sourceGroupSelect">{m.source_group()}</label>
                        <select class="form-select" id="sourceGroupSelect" bind:value={srcGroupId} 
                            aria-describedby="sourceGroupHelp">
                            {#each eventGroupState as eventGroupOption}
                                <option value={eventGroupOption.id}>{eventGroupOption.name}</option>
                            {/each}
                        </select>
                        <div id="sourceGroupHelp" class="form-text">{m.source_group_help()}</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="targetGroupSelect">{m.target_group()}</label>
                        <select class="form-select" id="targetGroupSelect" bind:value={trgGroupId}
                            aria-describedby="targetGroupHelp">
                            {#each eventGroupState as eventGroupOption}
                                <option value={eventGroupOption.id}>{eventGroupOption.name}</option>
                            {/each}
                        </select>
                        <div id="targetGroupHelp" class="form-text">{m.target_group_help()}</div>
                    </div>
                    <button class="btn btn-primary float-end" id="copyTcBtn" type="button" 
                        onclick={copyTimecodesFromGroup}
                        aria-label={m.copy_timecodes()}>{m.copy()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
